import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageService } from 'src/app/core/services/storage.service';
import { CommonService } from 'src/app/core/services/common.service';
import { CommonHttpService } from './common-http.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinesService {
private finesCount = new BehaviorSubject<number | null>(null);
finesCount$ = this.finesCount.asObservable();
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private commonService: CommonService,
    private _commonHttpService: CommonHttpService
  ) {}

  fetchFinesList(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchFinesList');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
            this.finesCount.next(this.commonService.decryptUsingAES256(response.body.data).length);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  fetchFinesCount(){
    return this.finesCount;
  }

  fetchFinesDetail(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchFinesDetail');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('questionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  fetchFinesHistoricalDetail(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchFinesHistoricalDetail');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          return response.body;
        } else {
          return error;
        }
      }));
  }

  fetchFinesHistory(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchFinesHistory');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('questionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }
}
